module.exports = __webpack_public_path__ + "img/cocinero.21ca4bcc.png";